import { boardEntityTypes } from 'modules/_shared/components/BoardsListHeader/constants/boardEntityTypes';
import { PartnerRepresentant } from './PartnerRepresentant';
import { Partner } from './Partner';

export enum BoardDelegations {
  ALL_MEMBERS = 'ALL_MEMBERS', // eslint-disable-line
  ALL_PARTNERS = 'ALL_PARTNERS', // eslint-disable-line
  SELECTED_PARTNERS = 'SELECTED_PARTNERS', // eslint-disable-line
  ALL_REPRESENTANTS = 'ALL_REPRESENTANTS', // eslint-disable-line
  SELECTED_REPRESENTANTS = 'SELECTED_REPRESENTANTS', // eslint-disable-line
}

export enum BoardDelegationRoles {
  PARTNER = 'PARTNER', // eslint-disable-line
  PARTNER_REPRESENTANT = 'PARTNER_REPRESENTANT', // eslint-disable-line
}

export type BoardDelegation = keyof typeof BoardDelegations;
export type BoardDelegationRole = keyof typeof BoardDelegationRoles;

export type BoardEntityTypes = keyof typeof boardEntityTypes;

export type BoardParticipantUserType =
  | 'USER'
  | 'PARTNER'
  | 'BENEFICIARY'
  | 'INVESTOR'
  | 'BENEFICIARY_DRAFT'
  | 'EMPLOYEE'
  | 'ADMIN'
  | 'PARTNER_REPRESENTANT'
  | 'DIRECTOR';

export type BoardAttendanceTypes =
  | 'HYBRID'
  | 'ONLINE'
  | 'FACE_TO_FACE'
  | 'WRITTEN_NO_SESSION';

export type BoardTypes =
  | 'ORDINARY'
  | 'EXTRAORDINARY'
  | 'ORDINARY_EXTRAORDINARY'
  | 'UNIVERSAL';

export type BoardStatus = 'PENDING' | 'ACTIVE' | 'CLOSED' | 'CANCELED';

export type BoardOrder = {
  _id: string;
  subject: string;
  description: string;
  voteType: string;
  voteValidation: string;
  holdingClassForValidation?: string;
};

export type BoardOrderVotesData = {
  id: string;
  favor: number;
  against: number;
  abstention: number;
  totalVotesNDPercent: number;
};

export type BoardVoterData = {
  voterId: string;
  voterName: string;
  voterType: string;
};

export type BoardVote = {
  _id?: string;
  order?: string;
  vote?: string;
  voterData?: BoardVoterData;
};

export type BoardVideo = {
  title: string;
  type: string;
  videoId: string;
  date?: Date | string;
};

export type BoardInstruction = {
  order: string;
  vote: string;
};

export type BoardParticipant = {
  _id: string;
  image?: string;
  member: string;
  name: string;
  email: string;
  address?: string;
  cif?: string;
  percentage?: number;
  userType: BoardParticipantUserType;
  assists: boolean;
  isAbsent: boolean;
  isRepresented: boolean;
  hasDelegated: boolean;
  hasPartnerRepresentant?: boolean;
  representative: PartnerRepresentant | Partner | string | null;
  votes: BoardVote[];
  delegationVote?: {
    instructionType: string;
    instructions: BoardInstruction[] | null;
  } | null;
  delegationDocuments?: string[];
  hasShares?: boolean;
  sharesCount?: number;
};

export type Board = {
  _id: string;
  name: string;
  date: string | Date;
  status: BoardStatus;
  isActive?: boolean;
  isVisible?: boolean;
  details?: string;
  participants: BoardParticipant[];
  delegationPartners?: string[];
  delegationRepresentants?: string[];
  president: string;
  secretary: string;
  attendanceType: BoardAttendanceTypes;
  announcement: string;
  comments: string;
  place: string;
  onlineAccess: string;
  digitalVoting: boolean;
  votePeriod: string;
  boardType: BoardTypes;
  entityType: BoardEntityTypes;
  delegationType: BoardDelegation;
  retriedAnnouncements?: string[];
  orders?: BoardOrder[];
  lastModifiedDate?: Date;
  society: string;
  societySharesCount?: number;
  actTemplate?: string;
  actDocument?: string;
  actCertificateTemplate?: string;
  actCertificateDocument?: string;
  announcementTemplate?: string;
  announcementDocument: string;
  attachedDocuments?: string[];
  delegationDocuments?: string[];
  privateDocuments?: string[];
  videos?: BoardVideo[];
};
export type BoardNewParticipant = Omit<
  BoardParticipant,
  '_id' | 'image' | 'address' | 'cif' | 'percentage' | 'hasShares'
>;
